import React, { useEffect, useState } from 'react'
import { RiAddFill } from 'react-icons/ri'
import { FaChevronCircleDown } from 'react-icons/fa'
import { FiUpload } from 'react-icons/fi'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

// import ReactGoogleAutocomplete from 'react-google-autocomplete'
import { SkyOutlinedButton } from '../../Components/Buttons'
import CustomInput from '../../Components/Input/CustomInput'
import DatePicker from '../../Components/Input/DatePicker'
import {
  createFleetCab,
  createFleetDriver,
  createFleetOwners,
} from '../../Services/cabapi/fleetapi'
import FleetCabReg from './FleetCabReg'
import FleetDriverReg from './FleetDriverReg'
import FleetRegister from './FleetRegister'
import { AADHAR_VERIFY, VERIFY_OTP } from '../../Services/cabapi/fleetggl'
import { useMutation } from '@apollo/client'

const RegFletDriver = () => {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})
  const [verifyAadhaar, { loading: submitLoading }] = useMutation(AADHAR_VERIFY)
  const [verifyOTP, { loading: verifyLoading }] = useMutation(VERIFY_OTP)

  const [fleetRegister, setFleetRegister] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    emergencyNumber: '',
    birthDate: '',
    address: '',
    city: '',
    state: '',
    operationCity: '',
    email: '',
    password: '',
  })
  const validateRegister = () => {
    const newErrors = {}
    if (!fleetRegister.firstName)
      newErrors.firstName = 'First name is required *'
    if (!fleetRegister.lastName) newErrors.lastName = 'Last name is required *'
    if (fleetRegister.mobileNumber.length < 10) {
      newErrors.mobileNumber = 'Enter 10 digit mobile number *'
    }
    if (fleetRegister.emergencyNumber.length < 10)
      newErrors.emergencyNumber = 'Enter 10 digit Emergency Number *'
    if (!fleetRegister.birthDate) {
      newErrors.birthDate = 'Date of birth is required *'
    } else {
      const today = new Date()
      const birthDate = new Date(fleetRegister.birthDate)
      const age = today.getFullYear() - birthDate.getFullYear()
      const month = today.getMonth() - birthDate.getMonth()
      const day = today.getDate() - birthDate.getDate()

      const validAge = age > 18 || (age === 18 && month >= 0 && day >= 0)

      if (!validAge) {
        newErrors.birthDate = 'You must be 18 or older to register *'
      }
    }

    if (!fleetRegister.address) newErrors.address = 'Address is required *'
    console.log('fleetRegister?.city', fleetRegister.city)
    console.log('fleetRegister?.city', typeof fleetRegister.city)
    if (!fleetRegister.city) newErrors.city = 'City is required *'
    if (!fleetRegister.state) newErrors.state = 'State is required *'
    if (!fleetRegister.operationCity)
      newErrors.operationCity = 'Operation City is required *'
    if (!fleetRegister.email) newErrors.email = 'Email is required *'
    if (!fleetRegister.password) newErrors.password = 'Password is required *'
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const [carDetails, setCarDetails] = useState([
    {
      carOwnerName: '',
      rcBook: '',
      carNo: '',
      permit: '',
      puc: '',
      color: '',
      variant: '',
      carType: '',
      registrationDate: '',
      registrationExpiryDate: '',
      insuranceExpiryDate: '',
      insurance: '',
      pucExpiryDate: null,
      permitExpiryDate: null,
      brand: '',
    },
  ])
  const validateCarDetials = () => {
    const newErrors = []
    carDetails.forEach((carDetail, index) => {
      const carErrors = {}
      if (!carDetail.carOwnerName)
        carErrors.carOwnerName = 'Car owner name is required *'
      if (!carDetail.rcBook) carErrors.rcBook = 'Rc Book is required *'
      if (!carDetail.carNo) carErrors.carNo = 'Car number is required *'
      if (!carDetail.permit) carErrors.permit = 'Permit is required *'
      if (!carDetail.puc) carErrors.puc = 'PUC is required *'
      if (!carDetail.color) carErrors.color = 'Car color name is required *'
      if (!carDetail.variant) carErrors.variant = 'Variant name is required *'
      if (!carDetail.registrationDate)
        carErrors.registrationDate = 'Registration Date is required *'
      if (!carDetail.registrationExpiryDate) {
        carErrors.registrationExpiryDate =
          'Registration Expiry Date is required *'
      } else {
        const registrationDate = new Date(carDetail.registrationDate)
        const registrationExpiryDate = new Date(
          carDetail.registrationExpiryDate
        )
        const diffTime = registrationExpiryDate - registrationDate
        const diffDays = diffTime / (1000 * 3600 * 24)
        const maxDiffDays = 5 * 365.25
        if (diffDays > maxDiffDays) {
          carErrors.registrationExpiryDate = 'Enter valid expiry date'
        }
        if (registrationExpiryDate < registrationDate) {
          carErrors.registrationExpiryDate = 'Enter valid expiry date'
        }
        if (registrationExpiryDate < new Date()) {
          carErrors.registrationExpiryDate = 'Enter valid expiry date'
        }
      }
      if (!carDetail.insuranceExpiryDate)
        carErrors.insuranceExpiryDate = 'Insurance is required *'
      if (!carDetail.insurance) carErrors.insurance = 'Insurance is required *'
      if (!carDetail.permitExpiryDate)
        carErrors.permitExpiryDate = 'Permit expiry is required *'
      if (!carDetail.pucExpiryDate)
        carErrors.pucExpiryDate = 'PUC expiry date is required *'
      if (!carDetail.variant) carErrors.variant = 'Car model is required *'
      if (Object.keys(carErrors).length > 0) {
        newErrors[index] = carErrors
      }
    })
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const [driverDetails, setDriverDetails] = useState([
    {
      aadharNumber: '',
      firstName: '',
      middleName: '',
      lastName: '',
      mobileNumber: '',
      email: '',
      trDate: '',
      permanentAddress: '',
      birthDate: '',
      licence_front: '',
      licence_back: '',
      aadhaar_front: '',
      aadhaar_back: '',
      police_verification: '',
      imageLink: '',
      isAadharVerified: false,
      showVerify: false,
      optCalled: false,
      verifyOtpCalled: false,
      showOtpInput: false,
      submitLoader: false,
      verifyLoader: false,
    },
  ])
  const validateDriverDetials = () => {
    const newErrors = []
    driverDetails.forEach((driverDetail, index) => {
      const driverErrors = {}
      if (!driverDetail.aadharNumber)
        driverErrors.DriverAadhaarNumber = 'Aadhar verification is required *'
      if (!driverDetail.firstName)
        driverErrors.DriverfirstName = 'Driver first name is required *'
      if (!driverDetail.middleName)
        driverErrors.DrivermiddleName = 'Driver middle name is required *'
      if (!driverDetail.lastName)
        driverErrors.DriverlastName = 'Driver last name is required *'
      if (!driverDetail.mobileNumber)
        driverErrors.DrivermobileNumber = 'Driver mobile number is required *'
      if (!driverDetail.email)
        driverErrors.Driveremail = 'Driver email is required *'
      if (!driverDetail.permanentAddress)
        driverErrors.DriverPermanentAddress =
          'Driver permanent address is required *'
      if (!driverDetail.birthDate) {
        console.log('inside birth')
        driverErrors.DriverBirthDate = 'Date of birth is required *'
      } else {
        const today = new Date()
        const birthDate = new Date(driverDetail.birthDate)
        const age = today.getFullYear() - birthDate.getFullYear()
        const month = today.getMonth() - birthDate.getMonth()
        const day = today.getDate() - birthDate.getDate()
        const validAge = age > 18 || (age === 18 && month >= 0 && day >= 0)
        if (!validAge) {
          driverErrors.DriverBirthDate = 'You must be 18 or older to register *'
        }
      }
      if (!driverDetail.aadhaar_front)
        driverErrors.Driveraadhaar_front = 'This field is required *'
      if (!driverDetail.aadhaar_back)
        driverErrors.Driveraadhaar_back = 'This field is required *'
      if (!driverDetail.trDate)
        driverErrors.DrivertrExpiryDate = 'Tr ExpiryDate is required *'
      if (!driverDetail.licence_front)
        driverErrors.Driverlicence_front = 'This field is required *'
      if (!driverDetail.licence_back)
        driverErrors.Driverlicence_back = 'This field is required *'
      if (!driverDetail.police_verification)
        driverErrors.Driverpolice_verification =
          'Driver police verification is required *'
      if (Object.keys(driverErrors).length > 0) {
        newErrors[index] = driverErrors
      }
    })

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }
  const [step, setStep] = useState(1)
  const handleNext = () => {
    if (step === 1) {
      console.log('fleet====>', fleetRegister)
      const isValid = validateRegister()
      if (!isValid) {
        toast?.error('Please fill all required fields.')
        return
      }
    }
    if (step === 2) {
      const isValid = validateCarDetials()
      if (!isValid) {
        toast?.error('Please fill all required fields.')
        return
      }
    }
    setStep((prevStep) => prevStep + 1)
  }
  const handleBack = () => {
    setStep((prevStep) => prevStep - 1)
  }
  const handleSubmit = async () => {
    const isDriverValid = validateDriverDetials()
    if (!isDriverValid) {
      validateDriverDetials()
      toast.error('Fill all required fields in register driver')
      return
    }
    try {
      const response = await createFleetOwners(fleetRegister)
      if (response) {
        if (response?._id && driverDetails.length > 0) {
          const driversPromises = driverDetails.map((driver) => {
            const driversData = new FormData()
            for (const key in driver) {
              if (
                key !== 'licence_front' &&
                key !== 'licence_back' &&
                key !== 'aadhaar_front' &&
                key !== 'aadhaar_back' &&
                key !== 'police_verification' &&
                key !== 'isAadharVerified' &&
                key !== 'showVerify' &&
                key !== 'optCalled' &&
                key !== 'verifyOtpCalled' &&
                key !== 'showOtpInput' &&
                key !== 'submitLoader' &&
                key !== 'verifyLoader'
              ) {
                driversData.append(key, driver[key])
              }
            }
            driversData.append('fleetOwnerId', response?._id)
            console.log('driversData', driversData)
            if (driver.licence_front)
              driversData.append('licence_front', driver?.licence_front)
            if (driver.licence_back)
              driversData.append('licence_back', driver?.licence_back)
            if (driver.aadhaar_front)
              driversData.append('aadhaar_front', driver?.aadhaar_front)
            if (driver.aadhaar_back)
              driversData.append('aadhaar_back', driver?.aadhaar_back)
            if (driver.police_verification)
              driversData.append(
                'police_verification',
                driver?.police_verification
              )
            return createFleetDriver(driversData)
          })
          const driverResponses = await Promise.all(driversPromises)
          console.log('Driver creation responses:', driverResponses)
        }
      }
      if (response) {
        if (response?._id && carDetails.length > 0) {
          const cabsPromises = carDetails.map((cab) => {
            const cabsData = new FormData()
            for (const key in cab) {
              if (
                key !== 'rcBook' &&
                key !== 'puc' &&
                key !== 'permit' &&
                key !== 'insurance' &&
                key != 'brand'
              ) {
                cabsData.append(key, cab[key])
              }
            }
            cabsData.append('fleetOwnerId', response?._id)
            if (cab.rcBook) cabsData.append('rcBook', cab.rcBook)
            if (cab.puc) cabsData.append('puc', cab.puc)
            if (cab.permit) cabsData.append('permit', cab.permit)
            if (cab.insurance) cabsData.append('insurance', cab.insurance)
            if (cab.google_location) {
              cabsData.append(
                'google_location',
                JSON.stringify(cab.google_location)
              )
            }
            return createFleetCab(cabsData)
          })
          const cabResponses = await Promise.all(cabsPromises)
          console.log('Cab creation responses:', cabResponses)
        }
      }
      navigate('/')
      toast.success('fleet owner registered successfully')
    } catch (error) {
      toast.error('Failed to register')
    }
  }

  return (
    <div>
      <div className="flex mx-3">
        <SkyOutlinedButton label={'Back'} onClick={() => navigate(-1)} />
      </div>
      <div className="flex justify-center">
        <div className="bg-white shadow-lg p-4 my-4 w-full sm:w-[80%] md:w-[70%] lg:w-[80%]">
          <div className="text-stone-500 text-xl md:text-2xl font-bold">
            Fleet Registration
          </div>
          {step === 1 && (
            <FleetRegister
              fleetRegister={fleetRegister}
              setFleetRegister={setFleetRegister}
              errors={errors}
            />
          )}
          {step === 2 && (
            <FleetCabReg
              carDetails={carDetails}
              setCarDetails={setCarDetails}
              errors={errors}
            />
          )}
          {step === 3 && (
            <FleetDriverReg
              driverDetails={driverDetails}
              setDriverDetails={setDriverDetails}
              errors={errors}
              verifyAadhaar={verifyAadhaar}
              verifyOTP={verifyOTP}
              submitLoading={submitLoading}
              verifyLoading={verifyLoading}
            />
          )}
          <hr className="my-5" />
          <div className="mt-5 flex justify-between gap-4">
            {step > 1 && (
              <button
                onClick={handleBack}
                className="bg-gray-500 px-4 py-1.5 rounded text-md font-semibold text-white hover:opacity-80"
              >
                Back
              </button>
            )}
            {step < 3 ? (
              <button
                onClick={handleNext}
                className="bg-sky-500 px-4 py-1.5 rounded text-md font-semibold text-white hover:opacity-80"
              >
                Save & Next
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className="bg-sky-500 px-4 py-1.5 rounded text-md font-semibold text-white hover:opacity-80"
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegFletDriver
